import { TRPCClientError } from "@trpc/client";
import { useEffect } from "react";
import { Tracking } from "~/instrumentation/tracking";
import { Button } from "./ui/button";

interface ErrorScreenProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
  error?: Error;
}

export function ErrorScreen({
  title = "Oops! Something went wrong.",
  message = "Try refreshing your page. If the issue persists, please contact us!",
  onRetry = () => window.location.reload(),
  error,
}: ErrorScreenProps) {
  const traceId = getTraceId(error);

  useEffect(() => {
    Tracking.capture({ event: "CLIENT_ERROR", data: { traceId } });
  }, []);

  return (
    <div className="flex h-full w-full items-center justify-center">
      <div className="flex flex-col items-start gap-2 max-w-100 px-7 pb-7 pt-6 rounded-lg border mb-12">
        <h1 className="text-lg">{title}</h1>
        <p className="text-muted-foreground text-sm">{message}</p>
        <Button onClick={onRetry} className="mt-2" size="sm">
          Reload page
        </Button>
        {traceId && (
          <p className="text-muted-foreground text-xs mt-2.5 -mb-1">
            Trace ID: {traceId}
          </p>
        )}
      </div>
    </div>
  );
}

function getTraceId(error: unknown) {
  if (error instanceof TRPCClientError && error.data?.traceId) {
    return error.data.traceId as string;
  }
  return;
}
